import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { SpinnerService } from "@shared/services/spinner.service";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from './services/auth.service';
import { SessionTimeoutService } from './services/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'clientApp';
  returnUrl!: string;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  routerSubscription: Subscription;
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private sessionTimeoutService: SessionTimeoutService,
  ) {}

  ngOnInit(): void {
    this.spinnerService.showSpinner.subscribe((status: any) => {
      status ? this.spinner.show() : this.spinner.hide();
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const publicRoutes = ['/login', '/register', '/username', '/password'];
        if (publicRoutes.some(route => event.url.startsWith(route))) {
          this.sessionTimeoutService.stopMonitoring();
        } else {
          this.sessionTimeoutService.startMonitoring();
        }
      }
    });
    this.isIframe = window !== window.parent && !window.opener;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    this.routerSubscription?.unsubscribe();
    this.sessionTimeoutService.stopMonitoring();
  }
}
